import React from 'react';
import SectionSurface from '../shared/SectionSurface';

const phases = [
  {
    step: '01',
    title: 'Discover & assess',
    description:
      'Understand your analytics landscape, data sources, reporting estate, and intelligence goals to scope a focused engagement.',
  },
  {
    step: '02',
    title: 'Architect data platform',
    description:
      'Design the target AWS infrastructure, Snowflake architecture, semantic models, and AI-ready data platform.',
  },
  {
    step: '03',
    title: 'Build pipelines & models',
    description:
      'Develop ingestion, transformation, semantic layers, and analytics engineering with lineage and governance.',
  },
  {
    step: '04',
    title: 'Deliver dashboards & analytics',
    description:
      'Stand up embedded Power BI experiences, executive dashboards, and interactive reporting portals.',
  },
  {
    step: '05',
    title: 'Enable AI & intelligence',
    description:
      'Layer in Snowflake Cortex, AI-powered reporting, predictive models, and decision intelligence interfaces.',
  },
  {
    step: '06',
    title: 'Optimize & scale',
    description:
      'Continuous monitoring, performance tuning, analytics governance, and platform evolution.',
  },
];

/**
 * How we work: section header flows into numbered vertical timeline.
 */
export default function Lifecycle() {
  return (
    <SectionSurface variant="muted" decor="flow" bleed="both" flowTop flowBottom overlap className="section">
      <div className="container-x">
        <div className="mx-auto max-w-3xl">
          <div className="text-center">
            <p className="eyebrow">How we work</p>
            <h2 className="mt-3 text-3xl font-semibold tracking-tight text-ink-900 sm:text-4xl">
              A clear path from data to decisions.
            </h2>
            <p className="mt-4 text-lg leading-relaxed text-ink-600">
              A six-phase engagement model from Snowflake data platforms to embedded analytics
              experiences, designed for modern analytics teams. Within each build phase we run Agile
              iterations with a clear Definition of Done.
            </p>
            <p className="mt-3">
              <a
                href="/delivery"
                className="inline-flex min-h-[24px] items-center text-sm font-semibold text-brand-600 hover:text-brand-700 underline-offset-2 hover:underline"
              >
                Explore the full delivery model →
              </a>
            </p>
          </div>

          <ol className="relative mt-12 sm:mt-14">
            <div
              aria-hidden="true"
              className="absolute bottom-3 left-[1.125rem] top-3 hidden w-px bg-gradient-to-b from-brand-200 via-brand-300/80 to-brand-100 sm:block"
            />
            {phases.map((p, index) => (
              <li
                key={p.step}
                className={`relative flex gap-5 sm:gap-6 ${index < phases.length - 1 ? 'pb-10' : ''}`}
              >
                <div className="relative z-10 flex w-9 shrink-0 flex-col items-center">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full border-2 border-brand-700 bg-white text-xs font-bold text-brand-700 shadow-sm">
                    {p.step}
                  </span>
                </div>
                <div className="min-w-0 flex-1 pt-0.5">
                  <h3 className="text-base font-semibold text-ink-900">{p.title}</h3>
                  <p className="mt-2 text-base leading-relaxed text-ink-600">{p.description}</p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </SectionSurface>
  );
}
